import { Component, h, Prop } from '@stencil/core'
import './udp-calendar-month.css'

@Component({
  tag: 'udp-calendar-month',
  styleUrl: 'udp-calendar-month.css',
  shadow: true,
})
export class UdpCalendarMonth {
  @Prop() props: any = {}

  componentWillLoad() { 
    
  }

  render() {
    return (
      <udp-calendar-base initialView='dayGridMonth' {...this.props}></udp-calendar-base>
    )
  }
}
